import { Flex } from 'antd'
import FacebookLogo from 'src/assets/logos/facebook.svg'
import InstagramLogo from 'src/assets/logos/instagram.svg'
import LinkedInLogo from 'src/assets/logos/linkedin.svg'
import { Link } from './link'
import { Body } from '../typography'

interface SocialMediaLinksProps {
  style?: React.CSSProperties
  labelColor?: string
}

export const SocialMediaLinks = ({ style, labelColor }: SocialMediaLinksProps) => {
  return (
    <Flex gap={10} align="center" justify="center" style={style} wrap>
      <Body
        $color="white"
        $size="small"
        $fontWeight="semiBold"
        style={labelColor ? { color: labelColor } : {}}
      >
        Social Media:
      </Body>
      <Flex gap={10} align="center" justify="center">
        <Link
          source={FacebookLogo}
          path="https://www.facebook.com/profile.php?id=61573155623846"
          altText="Facebook Logo"
        />
        <Link
          source={InstagramLogo}
          path="https://www.instagram.com/_connectup_"
          altText="Instagram Logo"
        />
        <Link
          source={LinkedInLogo}
          path="https://www.linkedin.com/company/connectup1"
          altText="Facebook Logo"
        />
      </Flex>
    </Flex>
  )
}
